export default __webpack_public_path__ + "static/media/WanDirection_0323.754e7937.svg";